import React, { Fragment } from "react";

import CompanyVideo from "../../../videos/profile_video.mp4";

const CompanyBackgroundPicVideoTwo = () => {
  return (
    <Fragment>
      <div className="profile-background-pics">
        <div className="background-image-container">
          <div className="background-video">
            <div className="loop-video-overlay">
              <div className="company-motto-container">
                <p className="company-motto blue">"Ready to work"</p>
              </div>
            </div>
            <video
              className="profile-video"
              src={CompanyVideo}
              controls
              autoPlay
              loop
            ></video>
          </div>
          <div className="profile-user-info">
            {/* {user && user.user === profile.user ? ( */}
            <div
              className="profile-user-info-button-blue blue"
              // onMouseOver={() => setColor(true)}
              // onMouseLeave={() => setColor(false)}
            >
              {/* <Link to={`/${user.channelid}/edit`}> */}
              <span
              // className={color ? "black" : "blue"}
              // onClick={() => setEditing(true)}
              >
                Employers
              </span>
              {/* </Link> */}
            </div>
            ) : (
            {/* <div
              className="profile-user-info-button-blue blue"
              // onClick={() => setemployerbio(true)}
            >
              Biography
            </div> */}
            {/* )} */}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CompanyBackgroundPicVideoTwo;
